import type { NestedHome } from "@habity/types";
import { getFiltersFromHome } from "../homes/filters";

/**
 * Build speculators URL with search params from home data
 */
export function getSpeculatorsPath(home: NestedHome | null): string {
  if (!home) return '/speculators';
  
  const filters = getFiltersFromHome(home);
  const params = new URLSearchParams();

  // Label for display in search input (same as old AdminMenu "Matcha spekulanter")
  // Format type:id:name is used by SpeculatorsGridView; address ID used for message prefill
  const address = home.address;
  const addressIdRaw = address?.id ?? home.address_id;
  const addressId = addressIdRaw != null ? String(addressIdRaw) : '0';
  const addressLabel = address?.street
    ? `${address.street}, ${address.city || ''}`.trim()
    : (address?.city || '');
  if (addressId !== '0' || addressLabel) {
    params.set('label', `address:${addressId}:${addressLabel}`);
  }
  if (home.id) {
    params.set('homeId', String(home.id));
  }

  // Add filter params
  if (filters.latitude) params.set('latitude', String(filters.latitude));
  if (filters.longitude) params.set('longitude', String(filters.longitude));
  if (filters.categories?.length) params.set('categories', filters.categories.join(','));
  if (filters.price_min) params.set('price_min', String(filters.price_min));
  if (filters.price_max) params.set('price_max', String(filters.price_max));
  if (filters.living_space_min) params.set('living_space_min', String(filters.living_space_min));
  if (filters.living_space_max) params.set('living_space_max', String(filters.living_space_max));
  if (filters.rooms_min) params.set('rooms_min', String(filters.rooms_min));
  if (filters.rooms_max) params.set('rooms_max', String(filters.rooms_max));
  
  const queryString = params.toString();
  return queryString ? `/speculators?${queryString}` : '/speculators';
}
